module.exports = __webpack_public_path__ + "static/media/NL.ba8f537b.svg";